<template>
  <div class="itemInfo-box">
    <div class="title">
      <h3>编目信息
        <el-button type="primary" style="margin-left: 10px;" v-if="(goEdit == null ? true : goEdit) && platform == 'VOD'" @click="goEditPage()">编辑</el-button>
        <el-button v-else-if="goEdit && !insideData.isPublish" @click="goEditPage()">编辑</el-button>
      </h3>
    </div>
    <el-form label-width="125px">
      <el-row>
        <el-col :span="8">
          <el-form-item :label="labelsName">{{insideData.name}}</el-form-item>
        </el-col>
        <el-col :span="labels?16:8" v-if="insideData.nameInitials">
          <el-form-item :label="labels?'名称首字母：':'名称首字母：'">{{insideData.nameInitials}}</el-form-item>
        </el-col>
        <el-col :span="8" v-if="insideData.subName">
          <el-form-item label="副标题：">{{insideData.subName}}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="分类：">{{insideData.category}}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="二级分类：">{{insideData.sndCategory}}</el-form-item>
        </el-col>
        <el-col :span="8" v-if="insideData.score">
          <el-form-item label="评分：">
            <el-rate v-model="insideData.score" disabled show-score text-color="#606266" score-template="{value}星" style="margin-top:5px">
            </el-rate>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="labels">
          <el-form-item label="标签：" class="label-key">
            <span v-for="item in labels" :key="item" class="labels">{{item}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="keywords">
          <el-form-item label="标签：" class="label-key">
            <span v-for="item in keywords" :key="item" class="labels">{{item}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="insideData.definition">
          <el-form-item label="清晰度：">{{insideData.definition}}</el-form-item>
        </el-col>
        <el-col :span="8" v-if="insideData.year">
          <el-form-item label="年份：">{{insideData.year}}</el-form-item>
        </el-col>
        <el-col :span="8" v-if="platform=='VOD'&&insideData.playMode">
          <el-form-item label="播放模式：">{{insideData.playMode}}</el-form-item>
        </el-col>
        <el-col :span="24" v-if="insideData.dsc">
          <el-form-item label="简介：">
            <div class="background-color">
              {{insideData.dsc}}
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-form label-width="125px">
      <el-row>
        <el-col :span="8" v-for="(item,index) in catalogData" :key="index">
          <template v-if="item.value">
            <el-form-item v-if="item.itemName == '海报：' || item.itemName == '横海报：' || item.itemName == '竖海报：'" :label="item.itemName">
              <el-image :src="item.value" style="height: 32px;">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </el-form-item>
            <el-form-item v-else-if="item.itemName == '时长单位：'" :label="item.itemName">{{item.value==1?'秒':'分'}}</el-form-item>
            <el-form-item v-else :label="item.itemName">{{item.value}}</el-form-item>
          </template>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { fetchCatalogItems } from '@/resource/api/index'
import { getCheckArr } from '@/utils'
export default {
  name: 'ItemInfo',
  props: ['insideData', 'goEdit', 'isProgram'],
  data () {
    return {
      labels: this.insideData.labels && this.insideData.labels.split(' '),
      labelsName: '',
      keywords: this.insideData.keywords && this.insideData.keywords.split(' '),
      catalogData: [],
      platform: process.env.VUE_APP_NODE_ENV

    }
  },
  watch: {
    insideData (value) {
      this.labelsName = ''
      this.fetchCatalogItems()
    }
  },
  mounted () {
    this.fetchCatalogItems()
    if (this.platform == 'UGC') {
      this.labelsName = '标题：'
    } else {
      this.isProgram == 'program' ? this.labelsName = '节目名称：' : this.labelsName = '节目集名称：'
    }
  },
  methods: {
    goEditPage () {
      this.$emit('goEditPage')
    },
    fetchCatalogItems () {
      var fixedAttr = []
      if (this.platform == 'UGC' && this.isProgram == 'program') {
        fixedAttr = ['name', 'nameInitials', 'subName', 'category', 'sndCategory', 'score', 'labels', 'definition', 'year', ' playMode', 'dsc', 'keywords', 'source', 'area', 'language', 'platform', 'isUnpack', 'vipFlag', 'isVR', 'is3D', 'materialType', 'isTrailer']
      } else {
        fixedAttr = ['name', 'nameInitials', 'subName', 'category', 'sndCategory', 'score', 'labels', 'definition', 'year', ' playMode', 'dsc', 'keywords']
      }
      const data = {
        category: this.insideData.category,
        type: this.isProgram == 'program' ? 'program' : 'set',
        platform: this.platform
      }
      fetchCatalogItems(data).then((res) => {
        if (res.code == '1') {
          this.catalogData = []
          if (res.result.length > 0) {
            res.result[0].sndCategory.forEach(item => {
              if (fixedAttr.indexOf(item.itemEnName) == -1) {
                this.catalogData.push(item)
              }
            })
            this.catalogData.forEach(item => {
              for (const i in item) {
                if (i == 'itemEnName') {
                  var valEnName = item[i]
                  item.value = this.insideData[valEnName]
                  item.itemName = item.itemName + '：'
                } else if (i == 'itemCheck') {
                  const itemVal = item[i]
                  const itemCheck = getCheckArr(itemVal)
                  if (itemCheck instanceof Array) {
                    item.itemCheck = itemCheck
                    itemCheck.forEach(checkItem => {
                      const key = Number(checkItem.key)
                      checkItem.label = checkItem.value
                      checkItem.value = checkItem.key ? isNaN(key) ? checkItem.value : key : checkItem.value
                    })
                    if (item.itemType == 'radio' || item.itemType == 'select') {
                      itemCheck.forEach(checkItem => {
                        if (checkItem.key == item.value) {
                          item.value = checkItem.label
                        }
                      })
                    }
                  } else {
                    item.itemCheck = itemCheck.message
                  }
                }
              }
            })
          }
        }
      })
    }
  }
}
</script>
<style lang="less">
.flex-form .el-form-item__label {
  font-size: 14px;
  font-weight: 400;
  color: #666978;
}
</style>
<style scoped lang="less">
.title {
  border-bottom: 1px solid rgba(0, 0, 0,.1);
  margin-bottom: 15px;
  font-weight: 400;
  color: #33343B;
}
.label-key {
  white-space: nowrap;
}
.labels{
  font-weight: 400;
  color: #595959;
  font-size: 12px;
  white-space: nowrap;
  border-radius: 2px;
  border: 1px solid #CFD1D8;
  padding: 0px 8px;
  margin: 0 3px;
}
.background-color{
  background-color:#F7F8FA;
  padding:5px 9px;
  border-radius:2px;
}
</style>
